import React from 'react'

import { PageLayout } from '@components/common/PageLayout'
import { Skeleton } from '@fourthwall/components'

export const AppsZapierSkeleton = () => (
  <PageLayout size="tiny">
    <Skeleton gap={16}>
      <Skeleton.Shape width={70} height={24} />
      <Skeleton.Shape width="85%" height={34} />
      <Skeleton.Shape width="90%" height={34} />
      <Skeleton.Shape width="100%" height={174} />
      <Skeleton.Shape width="100%" height={174} />
      <Skeleton.Shape width="100%" height={174} />
    </Skeleton>
  </PageLayout>
)
